module.exports = __webpack_public_path__ + "img/icon-mopeka-gas-sensor.ba6ebf04.svg";